import { PaginationComponent } from "@/components";
import CommonTableActions from "@/components/common/CommonTableActions";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import ROUTES from "@/constants/routes";
import { useGroupUIPermissionCheck } from "@/lib/hooks";
import React, { useMemo } from "react";

const FAQLisitng = ({
  userId,
  data,
  paginationDetails,
  tableColumns = [],
  permissionItems = {},
  actionFunctions = {},
  adminRole,
  permissionsList,
}) => {
  const columns = useMemo(() => tableColumns, []);

  return (
    <>
      <div className="mx-3 mt-3 border rounded-sm dark:border-[#fff]/10">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((column, index) => {
                if (
                  useGroupUIPermissionCheck(
                    adminRole,
                    permissionsList,
                    column.requirePermissionList
                  )
                ) {
                  return (
                    <TableHead
                      key={`${column.name}-${index + 1}`}
                      className={`${column.class} font-poppins-md text-[11px] sm:text-[13px] text-dark-weight-600 dark:text-light-weight-800`}
                    >
                      {column.name}
                    </TableHead>
                  );
                }
              })}
            </TableRow>
          </TableHeader>
          <TableBody className="font-poppins-rg text-[11px] sm:text-[13px] text-dark-weight-400 dark:text-light-weight-450">
            {data.map((item, index) => {
              const serialNumber =
                parseInt(paginationDetails.currentLimit) *
                  (parseInt(paginationDetails.currentPage) - 1) +
                index +
                1;

              return (
                <TableRow
                  key={item._id}
                  className={`${index === data?.length - 1 ? "border-0" : "border-b dark:border-[#fff]/10"}`}
                >
                  {/* Serial Number */}
                  <TableCell className={`font-poppins-md`}>
                    {serialNumber}
                  </TableCell>

                  {/* Question */}
                  <TableCell
                    className={`${item?.status ? "" : "line-through opacity-50"} text-center`}
                  >
                    {item?.question && item?.question.length > 50
                      ? `${item.question.slice(0, 50)} ...`
                      : item?.question || "N/A"}
                  </TableCell>

                  {/* Category */}
                  <TableCell
                    className={`${item?.status ? "" : "line-through opacity-50"} text-center`}
                  >
                    {item?.category_id?.name || "N/A"}
                  </TableCell>

                  {/* Actions */}
                  <TableCell className="text-right">
                    {useGroupUIPermissionCheck(adminRole, permissionsList, [
                      permissionItems.editItem,
                      permissionItems.deleteItem,
                      permissionItems.toggleActiveItem,
                      permissionItems.toggleFeaturedItem,
                    ]) && (
                      <CommonTableActions
                        actions={{
                          edit: true,
                          delete: true,
                          active: true,
                          feature: true,
                          default: false,
                        }}
                        editRoute={`${ROUTES.ADMIN_UPDATE_FAQ}/${item?._id || ""}`}
                        targetType="FAQ"
                        targetName={item?.question || "N/A"}
                        deleteArgs={[userId, item?._id || ""]}
                        toggleActiveArgs={[
                          userId,
                          item?._id || "",
                          item?.status || false,
                        ]}
                        toggleFeaturedArgs={[
                          userId,
                          item?._id || "",
                          item?.featured || false,
                        ]}
                        activeStatus={item?.status || false}
                        featuredStatus={item?.featured || false}
                        actionFunctions={actionFunctions}
                        permissionItems={permissionItems}
                        adminRole={adminRole}
                        permissionsList={permissionsList}
                      />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      {paginationDetails.totalItemsCount > paginationDetails.currentLimit && (
        <div className="mt-5 px-3 flex items-center gap-2">
          <PaginationComponent paginationDetails={paginationDetails} />
        </div>
      )}
    </>
  );
};

export default FAQLisitng;
